import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled/macro';
import { theme, Tooltip } from '@arnold/common';
import { OrganizationSurveysQuery } from '../../../generated/hooks';

const GreySpan = styled.span`
  color: ${theme.colors.text.secondary};
`;

interface IPopulationInfoProps {
  population?: number | null;
  answered?: number | null;
  recipients?: NonNullable<OrganizationSurveysQuery['organizationSurveys']>[0]['whitelistedRespondents'] | null;
}

export const PopulationInfo: FC<IPopulationInfoProps> = ({ population, answered, recipients }) => {
  const [t] = useTranslation('surveyOverviewRow');
  const validOpened = answered || 0;
  const baseTitle = `${t('population', { population })}${validOpened ? t('answered', { answered: validOpened }) : ''}`;
  const recipientsTitle =
    recipients && recipients.length
      ? `<br />${t('whitelist', {
          emails: recipients.map((r) => `${r.firstname} ${r.surname}`).join(', '),
        })}`
      : '';
  return (
    <Tooltip title={`${baseTitle}${recipientsTitle}`}>
      {population && (
        <>
          {Math.round(population ? (validOpened / population) * 100 : 100)}%{' '}
          <GreySpan>
            ({validOpened}/{population})
          </GreySpan>
        </>
      )}
    </Tooltip>
  );
};
